import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../../../context/AuthProvider';
import Toast from "../../../assetLibComponents/shared/Toast";
import { Mixpanel } from '../../../../Mixpanel';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from 'react-router';
import Loading from '../../Loading';


const VerifyTemp = () => {

  const authCtx = useContext(AuthContext);
  const VERIFY_URL = authCtx.verifyTemp;
  let navigate = useNavigate();
  const [eString, setEString] = useState("");
  const { code } = useParams();

  // const [action, setAction] = useState("");
  // const [code, setCode] = useState("");


  // const verifyEndpoint = VERIFY_URL+code ;

  useEffect(() => {
    if(code){
        verifyTemp()
    }
  }, []);

  

    const verifyTemp = async () => {
        try {
          const response = await axios.post(VERIFY_URL,{
            temp_client_id:code,
          });
          if (response?.data?.statusCode === "401") {
            console.log("ERR-401");
            // Toast(response?.data?.message, "E");
            Toast(response?.data?.message, "E");
            // setButtonLoader(false);
          }else if (response?.data?.statusCode === "403"){
            // console.log(response?.data?.data)
            // setResendMail(true);
            window.location.assign("/");
            localStorage.setItem("resendData", JSON.stringify(response?.data?.data));
          }else if (response?.data?.statusCode === "200") {
            Mixpanel.track('LoggedIn');
            Cookies.set("conditionalLogout", false );        
            authCtx.onLogin(response?.data);
            window.location.reload();
            const randomId = Math.floor(Math.random() * 900000) + 100000; // Generate a random token
            const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
            Cookies.set("chatid", `backend-${randomId}`, { expires: expiryDate }); // Set the cookie with the random token
            navigate("/Onboarding");
          } else {
            Toast(response?.data?.response, "E");
            // setButtonLoader(false);
          }
          Cookies.set("conditionalLogout", false );   
        //   setUsername("");
        //   setPassword("");
        } catch (err) {
        //   setButtonLoader(false);
          console.log("ERR",err);
        }
      };

  return (
    <div><Loading /></div>
  )
}

export default VerifyTemp